import React from 'react';

import MessageBox from './MessageBox';

interface RequestVerificationEmailSuccessProps {
  email: string;
}

const RequestVerificationEmailSuccess = (props: RequestVerificationEmailSuccessProps) => {
  return (
    <MessageBox
      header="Almost there..."
      message="We've sent a verification email to:"
      additionalMessage={props.email}
    />
  )
}

export default RequestVerificationEmailSuccess;
